import { Pagination } from "@mui/material";
import React, { useEffect } from "react";
// import { transactions } from "../../Utils/data";
import { ArchiveIcon, DownloadIcon, HomeIcon, PersonIcon } from "@radix-ui/react-icons";
import { checkTagValidity } from "../../Utils/Utils";
import { BASE_URL, LIST_PAIEMENT, TELECHARGEMENT_RECU } from "../../Utils/constant";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { useStoreApp } from "../../store/storeApp";
import { UploadRecuPaiement } from "../../views/Paiement/UploadRecu";
import { Pbo } from "../Widget/Pbo";
import { Periode } from "../Widget/Periode";

export const Paiement = () => {
    const paiements = useStoreApp()
    useEffect(() => {
        paiements.getData(LIST_PAIEMENT, { page: 0, param: ``, size: 8 }, ``)
    }, []);

    const more = (page) => {
        paiements.getData(LIST_PAIEMENT, { page: page - 1, param: ``, size: 8 }, ``)
    };

    return (
        <>
            <div className="mt-3 flex gap-1">
                <input
                    onChange={(e) => paiements.getData(LIST_PAIEMENT, { page: 0, param: e.target.value, size: 8 }, ``)
                    }
                    type="text"
                    placeholder="Rechercher element..."
                    className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                />
            </div>
            <div className=" grid  lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-5">
                {
                    paiements?.data?.data?.length === 0 ?
                        <div className="flex justify-center items-center">
                            <img src="" alt="" srcset="" />
                        </div>
                        : paiements?.data?.data?.length !== 0 && !paiements?.loading ?
                            paiements?.data?.data?.map((item) => (
                                <div className='relative bg-white rounded-xl border-slate-200 border shadow'>
                                    <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                                        <p className="text-[12px] font-semibold">N° {item?.numeroTicket}</p>
                                        <div className="ml-auto">
                                            <div className={` px-4 border  rounded-full py-[2px] text-xs text-green-600 font-semibold`}>{item?.status === 'SUCCES' ? 'Intention payé' : ""}</div>
                                        </div>
                                    </div>
                                    <div className=" px-3 py-2 ">
                                        <div className="items-center gap-2 space-y-3">
                                            <Periode item={item} />
                                            <Pbo pbo={item?.abonnement?.eligibilite?.pbo?.nom} port={item?.brin} />
                                            <div className="flex gap-1 my-3">
                                                <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                                                <div>
                                                    <p className="text-[13px] font-medium">{item?.abonnement?.client?.nomPrenoms}</p>
                                                    <p className="text-xs flex font-semibold gap-2"><span>{item?.abonnement?.client?.numero}</span> {" | "} <span>{item?.abonnement?.client?.secondNumero}</span>   </p>
                                                </div>
                                            </div>
                                            <h1 className="text-xs flex gap-1 items-center my-2">
                                                Forfait :{" "}
                                                {item?.abonnement?.forfait?.designation} - {item?.abonnement?.forfait?.categorie?.replace("_", "").toLowerCase()}
                                            </h1>
                                            <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                                                <p className="text-xs flex gap-1 items-center font-medium"><HomeIcon />{item?.abonnement?.batiment?.designation}</p>
                                                <p className="text-xs flex gap-1 font-medium"><ArchiveIcon /> {item?.abonnement?.equipement?.designation} </p>
                                            </div>
                                        </div>
                                        {checkTagValidity("DETAILS_PAIEMENT") ? <button onClick={() => { document.getElementById(`show${item.id}`).showModal() }} className="btn btn-sm bg-main text-xs my-2">Details de paiement</button> : null}

                                        {
                                            item?.recuPaiement === null ?
                                                <button button onClick={() => { document.getElementById(`upload${item.referencePaiement}`).showModal() }} className="btn btn-sm bg-black text-xs my-2 text-white">Uploader le recu</button>
                                                : null
                                        }

                                        <dialog id={`upload${item.referencePaiement}`} className="modal bg-slate-900/70">
                                            <div className="modal-box w-11/12 max-w-2xl">
                                                <div className="flex items-center justify-between p-3">
                                                    <div className="flex flex-row gap-2">
                                                        <h2 className="font-semibold flex flex-row items-center text-md">
                                                            Chargement de recu de paiement
                                                        </h2>
                                                    </div>
                                                    <form method="dialog">
                                                        <button
                                                            id={`fermer${item.referencePaiement}`}
                                                            className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                                                        >
                                                            ✕
                                                        </button>
                                                    </form>
                                                </div>
                                                <div className="">
                                                    <div className="bg-white p-3 rounded-lg">
                                                        <UploadRecuPaiement paiementRef={item?.referencePaiement} />
                                                    </div>
                                                </div>
                                            </div>
                                        </dialog>

                                        <dialog id={`show${item.id}`} className="modal bg-slate-900/70">
                                            <div className="modal-box w-11/12 max-w-2xl">
                                                <div className="flex items-center justify-between p-3">
                                                    <div className="flex flex-row gap-2">
                                                        <h2 className="font-semibold flex flex-row items-center text-md">
                                                            Details de paiment
                                                        </h2>
                                                    </div>
                                                    <form method="dialog">
                                                        <button
                                                            id="fermer_create_trajet"
                                                            className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                                                        >
                                                            ✕
                                                        </button>
                                                    </form>
                                                </div>
                                                <div className="">
                                                    <div className="bg-white p-3 rounded-lg border">
                                                        <div className="">
                                                            <dl className="divide-y divide-gray-100">
                                                                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt className="text-sm font-semibold text-gray-900">
                                                                        Date de paiement
                                                                    </dt>
                                                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                        {item?.datePaiement ? new Date(item?.datePaiement).toLocaleString() : '--'}
                                                                    </dd>
                                                                </div>

                                                                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt className="text-sm font-semibold leading-6 text-gray-900">
                                                                        Mode paiement
                                                                    </dt>
                                                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                        {item?.modePaiement}
                                                                    </dd>
                                                                </div>
                                                                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt className="text-sm font-semibold leading-6 text-gray-900">
                                                                        Montant
                                                                    </dt>
                                                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                        {item?.montant}
                                                                    </dd>
                                                                </div>
                                                                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt className="text-sm font-semibold leading-6 text-gray-900">
                                                                        Reference de paiement
                                                                    </dt>
                                                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                        {item?.referencePaiement}
                                                                    </dd>
                                                                </div>
                                                                {
                                                                    item?.modePaiement !== 'CASH' ? (
                                                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                            <dt className="text-sm font-semibold leading-6 text-gray-900">
                                                                                Reference MoMo
                                                                            </dt>
                                                                            <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                                {item?.referenceMtn}
                                                                            </dd>
                                                                        </div>
                                                                    ) :
                                                                        <div className="px-4 py-3 items-center sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                            <dt className="text-sm font-semibold leading-6 text-gray-900">
                                                                                Réçu de paiement (CASH)
                                                                            </dt>
                                                                            <div className="mt-1  text-sm font-medium leading-6 sm:col-span-2 sm:mt-0">
                                                                                <ul class="divide-y divide-gray-100 rounded-md border border-gray-200">
                                                                                    <li class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
                                                                                        <div class="flex w-0 flex-1 items-center">
                                                                                            <DownloadIcon />
                                                                                            <div class="ml-4 flex min-w-0 flex-1 gap-2">
                                                                                                <span class="truncate font-medium">Réçu de paiement par cash</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="ml-4 flex-shrink-0">
                                                                                            <a href={`${BASE_URL + TELECHARGEMENT_RECU}?reference=${item?.referencePaiement}`} target="_blank" class="font-medium cursor-pointer btn btn-sm" rel="noreferrer">Télécharger</a>
                                                                                        </div>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                }


                                                                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt className="text-sm font-semibold leading-6 text-gray-900">
                                                                        Nom et prenom de l'agent
                                                                    </dt>
                                                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                                                        {item?.abonnement?.agent?.nomPrenoms}
                                                                    </dd>
                                                                </div>
                                                            </dl>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </dialog>

                                    </div>
                                </div>
                            ))
                            :
                            <ContentLoading />
                }


            </div >
            <div className="my-3 flex justify-end">
                <Pagination
                    onChange={(event, newValue) => more(newValue)}
                    onSelect={(selectedPage) => more(selectedPage)}
                    count={paiements?.data?.totalPages}
                    variant="outlined"
                    color="primary"
                    shape="rounded"
                />
            </div>


        </>
    )
}
